// @ts-nocheck
import { Navigate, Route, Routes, Outlet } from 'react-router-dom';
import DemoLayout from '../../layouts/demo/DemoLayout';
import DemoOverviewPage from './DemoOverviewPage';
import FormsPage from './FormsPage';
import TablesPage from './TablesPage';
import UIRoutes from './ui';
import SettingsRoutes from './settings';
import AdvancedRoutes from './advanced';
import AnimationsRoutes from './animations';
import DomainsRoutes from './domains';
import DashboardRoutes from './Dashboard';
import AppsRoutes from './apps';
import AuthPagesRoutes from './auth-pages';

// Layout wrapper component
function DemoLayoutWrapper() {
  return (
    <DemoLayout>
      <Outlet />
    </DemoLayout>
  );
}

export default function DemoRoutes() {
  return (
    <Routes>
      <Route element={<DemoLayoutWrapper />}>
        <Route index element={<DemoOverviewPage />} />

        {/* Dashboard Widget Demo */}
        <Route path="dashboard/*" element={<DashboardRoutes />} />

        {/* Demo Applications */}
        <Route path="apps/*" element={<AppsRoutes />} />

        {/* UI Component Showcase */}
        <Route path="ui/*" element={<UIRoutes />} />

        {/* Advanced Component Showcase */}
        <Route path="advanced/*" element={<AdvancedRoutes />} />

        {/* Animation Showcase */}
        <Route path="animations/*" element={<AnimationsRoutes />} />

        {/* Domain Examples */}
        <Route path="domains/*" element={<DomainsRoutes />} />

        {/* Settings & Configuration */}
        <Route path="settings/*" element={<SettingsRoutes />} />

        {/* Auth Pages Demo */}
        <Route path="auth-pages/*" element={<AuthPagesRoutes />} />

        {/* Legacy Pages - To be reorganized in future phases */}
        <Route path="forms" element={<FormsPage />} />
        <Route path="tables" element={<TablesPage />} />

        {/* Backwards compatibility redirects */}
        <Route path="colors" element={<Navigate to="/app/demo/settings/colors" replace />} />
        <Route path="theme" element={<Navigate to="/app/demo/settings/theme" replace />} />
        <Route path="typography" element={<Navigate to="/app/demo/settings/typography" replace />} />
        <Route path="translations" element={<Navigate to="/app/demo/settings/translations" replace />} />
        <Route path="accessibility" element={<Navigate to="/app/demo/settings/accessibility" replace />} />

        <Route path="*" element={<Navigate to="." replace />} />
      </Route>
    </Routes>
  );
}
